import Link from 'next/link';
import T from '../../../../../common/components/T';
import { Img } from '../../../../../hybrid/wrappers';
import SingleButton from '../../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import css from './HelpComponent.module.scss';
const project = require('../../../../../scripts/configs/project.json');

export default function HelpComponent({ children }) {
    return (
        <div className={css.help}>
            <div className={css.helpComponent}>
                <div className={css.content}>
                    <div className={css.contentLeft}>
                        <p className={css.lightTitle}>{project.company}</p>
                        <p className={css.title}>
                            <T
                                textName='storeHelpComponentTitle'
                                defaultStr='Не можете определиться с выбором? Мы поможем!'
                                page='/store'
                            />
                        </p>
                        <p className={css.text}>
                            <T
                                textName='storeHelpComponentText'
                                defaultStr='Наш менеджер поможет вам найти продукт, который соответствует всем вашим критериям.'
                                page='/store'
                            />
                        </p>
                        <Link target='_blank' href={'https://wa.me/+77073212121'}>
                            <SingleButton
                                type='ok'
                                buttonText={<T textName='ask_a_question' defaultStr='Задать вопрос' page='/store' />}
                                customButton={{
                                    singleButton: css.button
                                }}
                            />
                        </Link>
                    </div>
                    <div></div>
                    <div className={css.contentImage}>
                        <Img src='/src/img/store/category/help.png' quality={100} />
                    </div>
                </div>
            </div>
            {children}
        </div>
    );
}
